import * as React from 'react';
import styled from 'styled-components';

import { fontWeights } from 'ui/theme';

import { BulkDeletionDetails } from './BulkDeletionDetails';
import { BulkDeletionMixedActionWarning } from './BulkDeletionMixedActionWarning';

import { foldersDeletableItemDisplayText } from '../../constants';
import { DeletableItem, DeletableItemDisplayText } from '../../types';
import { getItemsDeletionVerb, getItemsTypeName } from '../../utils';

type BulkDeletionModalPrompt = {
  displayTextForContentItems: DeletableItemDisplayText;
  content: DeletableItem[];
  folders: DeletableItem[];
  warning?: React.ReactNode;
};

const BoldText = styled.b`
  font-weight: ${fontWeights.bold};
`;

export const BulkDeletionPrompt = ({
  displayTextForContentItems,
  content,
  folders,
  warning,
}: BulkDeletionModalPrompt) => {
  const deletionVerb = getItemsDeletionVerb(content, folders, displayTextForContentItems);
  const itemsTypeName = getItemsTypeName(content, folders, displayTextForContentItems);
  const shouldShowBulkDeletionMixedActionWarning =
    !!folders.length &&
    !!content.length &&
    foldersDeletableItemDisplayText.actionName.verb !== displayTextForContentItems.actionName.verb;

  const BulkWarning = displayTextForContentItems.customMixedWarning
    ? displayTextForContentItems.customMixedWarning
    : BulkDeletionMixedActionWarning;
  return (
    <>
      <p>
        Are you sure that you want to {deletionVerb} these{' '}
        <BoldText>
          {content.length + folders.length} {itemsTypeName}
        </BoldText>
        ? {displayTextForContentItems.suffixText}
      </p>

      {shouldShowBulkDeletionMixedActionWarning && (
        <>
          <BulkWarning
            folders={folders}
            content={content}
            displayTextForContentItems={displayTextForContentItems}
          />
        </>
      )}
      <BulkDeletionDetails folders={folders} content={content} />

      {warning}
    </>
  );
};
